export default "__VITE_ASSET__CaIR2zAn__"